module.exports = __webpack_public_path__ + "img/4.eac28b65.png";